import { useNavigate } from "react-router-dom";
import { FIELDS } from "../utils/constants"
import { useEffect, useState } from "react";
import RequestModal from "../../containers/shared/RequestModal";
import GetRequestStyle from "../helpers/GetRequestStyle";
import GetServiceByCode from "../helpers/GetServiceByCode";
import ModalContainer from "../../containers/shared/ModalContainer";
import RadioInput from "../shared/RadioInput";
import apiClient from "../utils/apiClient";
import { CancellationReasons } from "../utils/constants";
import DownloadInvoice from "./DownloadInvoice";
import DownArrowIcon from "../icons/down-arrow";
import Toast from "../shared/Toast";
import InputField from "../shared/InputField";
import TextArea from "../shared/TextArea";
import NormalButton from "../shared/NormalButton";

export default function RequestsTable({ requests, hidePropertyAndUnitNames=false,type="sub", handleChangeRequsetStatus,closeAllModals,currentPage=false,pageSize=0,handleRefreshRequests=null,user=false ,fields=false,setIsLoading=false }) {

    const navigate = useNavigate();

    const [selectedRequest, setSelectedRequest] = useState();
    const [showRequestDetails, setShowRequestDetails] = useState(false);
    const [showCancelRequestModal, setShowCancelRequestModal] = useState(false);
    const [selectedCancellationReason, setSelectedCancellationReason] = useState('');
    const [selectedCancellationOption, setSelectedCancellationOption] = useState('');
    const [isCancelRequestDisabled, setIsCancelRequestDisabled] = useState(true);
    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [prevService, setPrevService] = useState(false);
    const [mainFieldChanged, setMainFieldChanged] = useState(false);

    const [showHelpModal, setShowHelpModal] = useState(false);
    const EmptyTicketForm = {
        "complaintType": "SERVICE",
        "complaintSubject": "",
        "complaintText": ""
    }
    const [ticketForm, setTicketForm] = useState(EmptyTicketForm);
    const [errors, setErrors] = useState(null);
    const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(true);
    const [toast, setToast] = useState({show: false,type: null, message:'' });

    useEffect(()=>{
        setDropDownOpen(false);
    },[requests])
    

    const sortBySoonest = (list) => {
        const currentDate = new Date()
        return list.sort(function (a, b) {
            let dateA = new Date(a.startWorkingDate)
            let dateB = new Date(b.startWorkingDate)
            if (dateA > currentDate || dateB > currentDate) {
                return -1;
            }
            return dateA - dateB;
        });
    }

    const getStartWorkingDate = (request) => {
        if(request?.startWorkingDate) {
            return new Date(request?.startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.startWorkingDate) {
                let sortedRequests;
                if(request?.units?.length > 1) {
                    sortedRequests = sortBySoonest(request?.units);
                } else {
                    sortedRequests = request?.units;
                }
                return new Date(sortedRequests[0].startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.startWorkingDate) {
                let sortedRequests;
                if(request?.subRequests?.length > 1) {
                    sortedRequests = sortBySoonest(request?.subRequests);
                } else {
                    sortedRequests = request?.subRequests;
                }
                return new Date(sortedRequests[0].startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
            } else {
                return 'غير محدد';
            }
        }
    }

    const getUnitsNames = (request) => {
        if(request?.unitName) {
            return request?.unitName;
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.unitName) {
                if(request?.units?.length > 1) {
                    let unitsNames = [];
                    let unitsText;
                    request.units?.map((unit, index) => {
                        unitsNames = [...unitsNames, unit?.unitName];
                    });
                    [...new Set(unitsNames)].map((p,i)=> i===0 ? unitsText = ''+p : unitsText += ' + ' + p);
                    return unitsText;
                } else {
                    return request?.units[0]?.unitName;
                }
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.unitName) {
                if(request?.subRequests?.length > 1) {
                    let unitsNames = [];
                    let unitsText;
                    request.subRequests?.map((sub, index) => {
                        unitsNames = [...unitsNames, sub?.unitName];
                    });
                    [...new Set(unitsNames)].map((p,i)=> i===0 ? unitsText = ''+p : unitsText += ' + ' + p);
                    return unitsText;
                } else {
                    return request?.subRequests[0]?.unitName;
                }
            } else {
                return 'غير محدد';
            }
        }
    }

    const getPropertiesNames = (request) => {
        if(request?.propertyName) {
            return request?.propertyName;
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.propertyName) {
                if(request?.units?.length > 1) {
                    let propertiesNames = [];
                    let propertiesText;
                    request.units?.map((unit, index) => {
                        propertiesNames = [...propertiesNames, unit?.propertyName];
                    });
                    [...new Set(propertiesNames)].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
                    return propertiesText;
                } else {
                    return request?.units[0]?.propertyName;
                }
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.propertyName) {
                if(request?.subRequests?.length > 1) {
                    let propertiesNames = [];
                    let propertiesText;
                    request.subRequests?.map((sub, index) => {
                        propertiesNames = [...propertiesNames, sub?.propertyName];
                    });
                    [...new Set(propertiesNames)].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
                    return propertiesText;
                } else {
                    return request?.subRequests[0]?.propertyName;
                } 
            } else {
                return 'غير محدد';
            }
        }
    }

    const getFieldName = (request) => {
        if(request?.field?.name?.indexOf("'") > -1) {
            return request?.field?.name?.split("'")[1];
        } else {
            if(request?.field?.name) {
                return request?.field?.name;
            } else {
                return request?.field;
            }
        }
    }


    requests.sort((a, b) => {
        if (a.prettyId < b.prettyId) return 1;
        if (a.prettyId > b.prettyId) return -1;
        return 0;
    });
      

    const handleClickRequestRow = (request) => {
        setDropDownOpen(false);
        setPrevService(false);
        if(type === 'sub') {
            // navigate(`/ar/subRequest/${request?._id}`);
            setSelectedRequest(request);
            setSelectedRequestId(request?._id);
            setShowRequestDetails(true);
            if(request?.requestActivityLogs && Array.isArray(request?.requestActivityLogs) && request?.requestActivityLogs?.length > 0 && request?.field !== request?.requestActivityLogs[request?.requestActivityLogs?.length-1]?.previousField?.field) {
                setMainFieldChanged(request?.field);
            } else {
                setMainFieldChanged(false);
            }
        } else {
            if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0) {
                if(request?.subRequests?.length > 1) {
                    navigate(`/ar/requests/${request?._id}`);
                } else {
                    const subrequest = request?.subRequests[0];
                    subrequest.field = request?.field;
                    subrequest.createdBy = request?.createdBy;
                    subrequest.prettyId = request?.prettyId || subrequest?.prettyId;
                    setSelectedRequest(subrequest);
                    setSelectedRequestId(request?._id);
                    setShowRequestDetails(true);
                    if(request?.requestActivityLogs && Array.isArray(request?.requestActivityLogs) && request?.requestActivityLogs?.length > 0 && request?.field !== request?.requestActivityLogs[request?.requestActivityLogs?.length-1]?.previousField?.field) {
                        setMainFieldChanged(request?.field);
                    } else {
                        setMainFieldChanged(false);
                    }
                }
            }
        }
    }

    const handleCloseModal = () => {
        setShowRequestDetails(false);
    }

    const handleClickCancelRequest = () => {
        setShowRequestDetails(false);
        setSelectedCancellationReason('');
        setSelectedCancellationOption('');
        setShowCancelRequestModal(true);
    }

    const handleCloseCancelRequestModal = () => {
        setShowCancelRequestModal(false);
    }

    const handleClickCancelRequestAction = async() => {
        setIsCancelRequestDisabled(true);
        let finalId;
        if(selectedRequest?.businessRequestId) {
            finalId = selectedRequest?.businessRequestId;
        } else {
            finalId = selectedRequestId;
        }
         try {
            const response = await apiClient.patch(`/b-business-requests/${finalId}/cancel`,{"cancellationReason": selectedCancellationReason});
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowCancelRequestModal(false);
                handleRefreshRequests();
            }
        } catch(err) {}
    }

    useEffect(()=>{
        if (typeof selectedCancellationReason === 'string' && selectedCancellationReason?.length > 3) {
            setIsCancelRequestDisabled(false);
        } else {
            setIsCancelRequestDisabled(true);
        }
    },[selectedCancellationReason])

    useEffect(()=>{
        if(closeAllModals) {
            setShowRequestDetails(false);
        }
    },[closeAllModals])
    
    const handleClickCancelConfirmPriceChange = () => {
        if(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.needConfirmation) {
            AcceptSubRequestPriceEditing();
        } else {
            AcceptRequestPriceEditing();
        }
    }


    const AcceptRequestPriceEditing = async () => {
        setIsLoading(true);
        let requestId = selectedRequestId;
        if(selectedRequest?.businessRequestId) {
            requestId = selectedRequest?.businessRequestId;
        }
        try {
            const response = await apiClient.patch(`/b-business-requests/${requestId}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowRequestDetails(false);
                handleRefreshRequests();
            }
        } catch(err) {}
    }

    const AcceptSubRequestPriceEditing = async () => {
        setIsLoading(true);
        try {
            const response = await apiClient.patch(`/b-business-requests/sub-request/${selectedRequest?._id}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowRequestDetails(false);
                handleRefreshRequests();
            }
        } catch(err) {}

    }

    const getFieldNameAr = (field) => {
        if(fields) {
            return fields?.find(f=>f?.field?.code === field)?.field?.name?.ar;
        } else {
            return FIELDS[field]?.ar;
        }
    }

    const getFieldIcon = (field) => {
        if(FIELDS[field]?.icon) {
            return "url('/assets/images/"+FIELDS[field]?.icon+"')";
        } else {
            return "url('"+fields?.find(f=>f?.field?.code === field)?.field?.url+"')";
        }
    }

    const getFieldCategoryAr = (field,subFieldCode) => {
        if(fields) {
            let fieldCategory;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        fieldCategory = d?.device?.name?.ar;
                    }
                })
            })
            return fieldCategory;
        } else {
            return GetServiceByCode(field, subFieldCode)[0];
        }
    }

    const getSubFieldAr = (field,subFieldCode) => {
        if(fields) {
            let subField;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        subField = m?.name?.ar;
                    }
                })
            })
            return subField;
        } else {
            return GetServiceByCode(field, subFieldCode)[1];
        }
    }

    const getRequestTotal = (request) => {
        let total = 0;
        if(request?.status === 'awaiting-price-confirmation') {
            if(request?.requestActivityLogs) {
                total = request?.requestActivityLogs[request?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.total || 0;
            }
            if(request?.subRequestActivityLogs) {
                total = request?.subRequestActivityLogs[request?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.total || 0;
            }
        } else {
            total = request?.invoiceDetails?.total || 0;
        }
       return total?.toFixed(2);
    }

    const handleClickChangeRequestStatus = async(status) => {
        setIsLoading(true);
        try {
            const response = await apiClient.patch(`/b-business-requests/status/${selectedRequestId}`,{status: status});
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setIsLoading(false);
                setShowRequestDetails(false);
                handleRefreshRequests();
            }
            setIsLoading(false);
        } catch(err) {setIsLoading(false);}
    }

    const handleClickShowHelpModal = () => {
        setTicketForm(EmptyTicketForm);
        setShowRequestDetails(false);
        setShowHelpModal(true);
    }

    const handleClickCloseHelpModal = () => {
        setShowHelpModal(false);
    }

    const handleClickSendTicket = async () => {
        setIsLoading(true);
        try {
            const response = await apiClient.post(`/b-users/${selectedRequest?._id}/send-complaint-from-business`,ticketForm);
            if([200,201,204].includes(response?.status)) {
                setShowHelpModal(false);
                setIsLoading(false);
                setToast({show:true,type:'success',message:'تم إرسال الشكوي بنجاح'});
            } else {
                setIsLoading(false);
                setToast({show:true,type:'error',message:'حدث خطأ في إرسال الشكوي'});
            }
        } catch(err) {
            setIsLoading(false);
            setToast({show:true,type:'error',message:err?.response?.data?.message});
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(ticketForm && ticketForm?.complaintSubject && ticketForm?.complaintText && ticketForm?.complaintSubject.toString().length > 3 && ticketForm?.complaintText.toString().length > 3) {
            setIsActionButtonDisabled(false);
        } else {
            setIsActionButtonDisabled(true);
        }
    },[ticketForm])

    return (
        <>
        <div className="">
            <table className="w-full mt-[30px]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">رقم الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">تاريخ البدء</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">أنشئ بواسطة</th>
                    {/* {!hidePropertyAndUnitNames && <><th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">المنشأة</th> */}
                    {!hidePropertyAndUnitNames && <><th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الوحدة</th></>}
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الخدمة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">التكلفة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">حالة الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]"></th>
                </tr>
                </thead>
                <tbody>
                {requests.map((request, index) => {;
                    return (
                    <tr key={`requests-${index}`} className={`${index !== requests?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === requests?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickRequestRow(request)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.prettyId}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getStartWorkingDate(request)}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.statuses[0]?.createdBy?.name || request?.createdBy?.name}</td>
                        {/* {!hidePropertyAndUnitNames && <><td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getPropertiesNames(request)}</td> */}
                        {!hidePropertyAndUnitNames && <><td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getUnitsNames(request)}</td></>}
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getFieldNameAr(request?.field) || 'غير معرف'}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}><span className="font-[600]">{getRequestTotal(request)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap`} onClick={()=>handleClickRequestRow(request)}><span className={`font-[600] ${GetRequestStyle(request?.status,'color')}`}>{GetRequestStyle(request?.status)}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === requests?.length-1 && 'rounded-bl-[8px]'}`}>
                            {request?.status === 'awaiting-price-confirmation' ? <div className="cursor-pointer select-none w-[16px] h-[16px] !bg-center !bg-contain" style={{background:"url('/assets/images/more.svg')"}} onClick={()=>setDropDownOpen(prev=> prev === index+1 ? false : index+1)}></div> : ''}
                            {dropDownOpen === index+1 ? <div className="bg-white py-[8px] px-[12px] w-[142px] absolute end-[20px] rounded-b-[8px] shadow-[0px_0px_5px_0px_rgba(0,0,0,0.05)]">
                                <div className="cursor-pointer py-[8px] px-[12px] font-[500] text-[16px] text-grey-600" onClick={()=>handleClickRequestRow(request)}>مراجعة التغييرات</div>
                            </div> : ''}
                        </td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          { showRequestDetails && <RequestModal textColor={(selectedRequest?.status === 'awaiting-price-confirmation') ? 'text-grey-900' : 'text-white'} bgColor={['active','pending','done','postponed'].includes(selectedRequest?.status) ? 'bg-blue': GetRequestStyle(selectedRequest?.status,'bg')} heading={['active','pending','done','postponed'].includes(selectedRequest?.status) ? 'طلب تحت العمل' :GetRequestStyle(selectedRequest?.status,'heading')} handleCloseModal={handleCloseModal}>
            {selectedRequest?.status === 'pending-approval-exceeded-limit' ? <div className="bg-[#FFF0F0] h-[42px] leading-[42px] text-[#D80000] font-[500] cairo-font px-[12px]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[8px]">
                    <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="#D80000"/>
                    <path d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z" fill="#D80000"/>
                    <path d="M12 16.9999C11.87 16.9999 11.74 16.9699 11.62 16.9199C11.5 16.8699 11.39 16.7999 11.29 16.7099C11.2 16.6099 11.13 16.5099 11.08 16.3799C11.03 16.2599 11 16.1299 11 15.9999C11 15.8699 11.03 15.7399 11.08 15.6199C11.13 15.4999 11.2 15.3899 11.29 15.2899C11.39 15.1999 11.5 15.1299 11.62 15.0799C11.86 14.9799 12.14 14.9799 12.38 15.0799C12.5 15.1299 12.61 15.1999 12.71 15.2899C12.8 15.3899 12.87 15.4999 12.92 15.6199C12.97 15.7399 13 15.8699 13 15.9999C13 16.1299 12.97 16.2599 12.92 16.3799C12.87 16.5099 12.8 16.6099 12.71 16.7099C12.61 16.7999 12.5 16.8699 12.38 16.9199C12.26 16.9699 12.13 16.9999 12 16.9999Z" fill="#D80000"/>
                </svg>
                لقد تخطيت حد التنبيه لمصاريف الصيانة عن هذة الوحدة
            </div> : ''}
            <div className={`${['pending','done','reviewed'].includes(selectedRequest?.status) || (selectedRequest?.status === 'awaiting-price-confirmation' && ( (selectedRequest?.createdBy === user?._id) || (selectedRequest?.createdBy?._id === user?._id) ) ) || (selectedRequest?.status === 'pending-approval-exceeded-limit' && ['OWNER','ADMINISTRATOR'].includes(user?.role)) ? 'pb-[87px]' : ''}`}>
                { ['active','pending','done','postponed','awaiting-price-confirmation'].includes(selectedRequest?.status) ? <div className="">
                    <div className="text-center pt-[12px] pb-[24px]">
                        {selectedRequest?.status === 'done' && <img src="/assets/images/request-done.svg" alt="" className="w-[80px] h-[80px] align-middle inline-block select-none" />}
                        {['pending','postponed','awaiting-price-confirmation'].includes(selectedRequest?.status ) && !selectedRequest?.assignedWorker  && !selectedRequest?.isWorkerArrived && <img src="/assets/images/request-sent.svg" alt="" className="w-[80px] h-[80px] align-middle inline-block select-none" />}
                        {['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker  && !selectedRequest?.isWorkerArrived && <img src="/assets/images/request-assigned.svg" alt="" className="w-[80px] h-[80px] align-middle inline-block select-none" />}
                        {['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && selectedRequest?.isWorkerArrived && <img src="/assets/images/request-arrived.svg" alt="" className="w-[80px] h-[80px] align-middle inline-block select-none" />}
                    </div>
                    <div className="text-center">
                        {selectedRequest?.status === 'done' && <>
                            <h2 className="text-[32px] font-[600] leading-[48px] text-grey-900">تم تنفيذ الخدمة</h2>
                            <p className="text-[20px] font-[600] text-grey-900 leading-[30px] mt-[8px]">تم الانتهاء من الخدمات المطلوبة  </p>
                        </>}
                        {['pending','postponed'].includes(selectedRequest?.status) && !selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived && <>
                            <h2 className="text-[32px] font-[600] leading-[48px] text-grey-900">تم إرسال الطلب</h2>
                            <p className="text-[20px] font-[600] text-grey-900 leading-[30px] mt-[8px]">تم قبول الطلب و سيبدأ التنفيذ في الوقت المحدد من قبلك</p>
                        </>}
                        {['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived && <>
                            <h2 className="text-[32px] font-[600] leading-[48px] text-grey-900">تم تعيين الفني</h2>
                            <p className="text-[20px] font-[600] text-grey-900 leading-[30px] mt-[8px]">تم تعيين الفني و سيصل إلى موقع الوحدة في الوقت المحدد </p>
                        </>}
                        {['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && selectedRequest?.isWorkerArrived && <>
                            <h2 className="text-[32px] font-[600] leading-[48px] text-grey-900">بدء تنفيذ الخدمة</h2>
                            <p className="text-[20px] font-[600] text-grey-900 leading-[30px] mt-[8px]">تم وصول الفني إلى موقع الوحدة وبدء العمل</p>
                        </>}
                         {selectedRequest?.status === 'awaiting-price-confirmation' && <>
                            <h2 className="text-[32px] font-[600] leading-[48px] text-grey-900">تم تعديل الطلب</h2>
                            {mainFieldChanged ? <p className="text-[20px] font-[600] text-grey-900 leading-[30px] mt-[8px]">تم تعديل الخدمة الرئيسية إلى خدمة {`(${getFieldNameAr(mainFieldChanged)})`}</p> : ''}
                            <p className="text-[20px] font-[600] text-grey-900 leading-[30px] mt-[8px] pb-[16px]">الرجاء تأكيد الموافقة على تفاصيل الطلب المحدّثة وإتمام عملية الدفع  </p>
                            <div className="border-t-[1px] border-t-grey-200 mx-[16px]"></div>
                        </>}
                    </div>
                    {selectedRequest?.status !== 'awaiting-price-confirmation' ?<div className="text-center mt-[32px] mb-[16px]">
                        <div className={`inline-block align-top h-[12px] me-[10px] ${['pending','postponed'].includes(selectedRequest?.status) && !selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived ? 'w-[300px] bg-[#C2E8FF]' : 'w-[125px] bg-blue'}`}></div>
                        <div className={`inline-block align-top h-[12px] me-[10px] ${['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived ? 'w-[300px]' : 'w-[125px]'} ${['pending','postponed'].includes(selectedRequest?.status) && !selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived ? 'bg-grey-100' : ['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived ? 'bg-[#C2E8FF]' : 'bg-blue'}`}></div>
                        <div className={`inline-block align-top h-[12px] me-[10px] ${['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && selectedRequest?.isWorkerArrived ? 'w-[300px]' : 'w-[125px]'} ${( (['pending','postponed'].includes(selectedRequest?.status) && !selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived) || (['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && !selectedRequest?.isWorkerArrived) ) ? 'bg-grey-100' : ['active','postponed'].includes(selectedRequest?.status) && selectedRequest?.assignedWorker && selectedRequest?.isWorkerArrived ? 'bg-[#C2E8FF]' : 'bg-blue'}`}></div>
                        <div className={`inline-block align-top h-[12px] me-[10px] ${selectedRequest?.status === 'done' ? 'w-[125px]' : 'w-[125px]'} ${['pending','active','postponed'].includes(selectedRequest?.status) ? 'bg-grey-100' : selectedRequest?.status === 'done' ? 'bg-blue' : 'bg-blue'}`}></div>
                    </div> : ''}
                    <div className="border-t-[1px] border-t-grey-200 mx-[16px]"></div>
                </div> : ''}
                <div className="">
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] px-[16px]">
                        <span className="text-[12px] text-grey-900 font-[600]">رقم الطلب:</span> {selectedRequest?.prettyId}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">تاريخ البدء:</span> {new Date(selectedRequest?.startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'})}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">أنشئ بواسطة:</span> {selectedRequest?.statuses[0]?.createdBy?.name}
                    </div>
                    {/* <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">المنشأة:</span> {selectedRequest?.propertyName}
                    </div> */}
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">الوحدة:</span> {selectedRequest?.unitName}
                    </div>
                    {selectedRequest?.notes ? <div className="text-[14px] text-grey-600 font-[500] my-[10px] mx-[16px] border-t-[1px] min-h-[30px] border-t-grey-200 whitespace-nowrap">
                        <span className="text-[12px] text-grey-900 font-[600] inline-block align-top w-[85px] leading-[30px]">ملاحظات الخدمة:</span>
                        <p className="inline-block align-top ms-[8px] whitespace-normal w-[calc(100%-93px)] pt-[5px]"> {selectedRequest?.notes?.notes || 'غير معرف'}</p>
                    </div> : ''} 
                </div>
                <div  className="p-[16px] bg-grey-50 my-[10px] relative">
                    <div className="flex flex-nowrap mb-[10px]">
                        <div className="w-[50%] text-[17px] text-grey-900 font-[600]">تفاصيل الخدمه</div>
                        <div className="w-[50%] text-end"></div>
                    </div>
                    {selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.subFields?.map((service,index)=>{
                            return (
                                <div key={`initialWorkList-${selectedRequest?._id}-${index}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                    <div className="w-full max-w-[228px]">
                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                        <div className="inline-block align-middle">
                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field)}</p>
                                        </div>
                                    </div>
                                    <div className="w-full max-w-[180px]">
                                        <p className="text-[#616161]">نوع الخدمة</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">الكمية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                    </div>
                                </div>
                            )
                        }) 
                    : selectedRequest?.initialWorkList?.map((service,index)=>{
                        return (
                            <div key={`initialWorkList-${selectedRequest?._id}-${index}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                <div className="w-full max-w-[228px]">
                                    <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(selectedRequest?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                    <div className="inline-block align-middle">
                                        <p className="text-[#616161]">الخدمة الأساسية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(selectedRequest?.field)}</p>
                                    </div>
                                </div>
                                <div className="w-full max-w-[180px]">
                                    <p className="text-[#616161]">نوع الخدمة</p>
                                    <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(selectedRequest?.field, service?.maintenanceCode)}</p>
                                </div>
                                <div className="w-full max-w-[280px]">
                                    <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                    <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(selectedRequest?.field, service?.maintenanceCode)}</p>
                                </div>
                                <div className="w-full max-w-[280px]">
                                    <p className="text-[#616161]">الكمية</p>
                                    <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                </div>
                            </div>
                         )
                    })}
                    <div className="flex flex-nowrap mb-[10px]">
                        <div className="w-full text-[16px] text-grey-900 font-[600]">الوحدات</div>
                    </div>
                    <div>
                        <div className="inline-block align-middle px-[8px] rounded-[8px] h-[32px] leading-[32px] text-grey-900 font-[500] text-[16px] bg-[rgba(30,41,59,0.1)] me-[10px]">
                            {selectedRequest?.unitName}
                        </div>
                    </div>
                    {selectedRequest?.status === 'done' && <DownloadInvoice subRequestId={selectedRequest?._id} prettyId={selectedRequest?.prettyId} />}
                </div>
                {selectedRequest?.status === 'awaiting-price-confirmation' ? <div  className={`bg-grey-200 my-[10px] mt-[-10px] relative max-h-[42px] transition-all duration-300 overflow-hidden border-y border-[transparent] ${prevService ? '!max-h-[1000px] !bg-grey-100 !border-grey-600' : ''}`}>
                    <div className="cursor-pointer h-[42px] leading-[42px] flex flex-nowrap select-none px-[16px]" onClick={()=> setPrevService(prev=>!prev)}>
                        <div className="w-[75%] text-[17px] font-[600] text-grey-900">تفاصيل الخدمة المعدلة</div>
                        <div className="w-[25%] text-end"><DownArrowIcon revarse={prevService} /></div>
                    </div>
                    {selectedRequest?.subRequestActivityLogs && Array.isArray(selectedRequest?.subRequestActivityLogs) && selectedRequest?.subRequestActivityLogs?.length > 0 ? 
                    <div className="pt-[16px] px-[16px] opacity-50">
                        {selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.subFields && selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.subFields?.map((service,i)=>{
                            return (
                                <div key={`sub-request-activity-log-${i}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                    <div className="w-full max-w-[228px]">
                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                        <div className="inline-block align-middle">
                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field)}</p>
                                        </div>
                                    </div>
                                    <div className="w-full max-w-[180px]">
                                        <p className="text-[#616161]">نوع الخدمة</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">الكمية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                    </div>
                                </div>
                            )}
                        )}
                        <div className="flex flex-nowrap mb-[10px]">
                            <div className="w-full text-[16px] text-grey-900 font-[600]">الوحدات</div>
                        </div>
                        <div>
                            <div className="inline-block align-middle px-[8px] rounded-[8px] h-[32px] leading-[32px] text-grey-900 font-[500] text-[16px] bg-[rgba(30,41,59,0.1)] me-[10px]">
                                {selectedRequest?.unitName}
                            </div>
                        </div>
                        <div className="h-[24px] leading-[24px] my-[17px] flex flex-nowrap select-none">
                            <div className="w-[75%] text-[17px] font-[600] text-grey-900">اجمالي الفاتورة القديمة</div>
                            <div className="w-[25%] text-end font-bold ">{selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>: ''}
                </div> : ''}
                <div className="p-[16px]">
                    <p className="mb-[16px] font-[600] text-[16px] text-grey-900">تفاصيل الفاتورة</p>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي قطع الغيار المطلوبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.partsCost.toFixed(2) : selectedRequest?.invoiceDetails?.partsCost?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي راتب العمالة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.workerWage.toFixed(2) :  selectedRequest?.invoiceDetails?.workerWage?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">المجموع</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? Number(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.workerWage + selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.partsCost)?.toFixed(2) : Number(selectedRequest?.invoiceDetails?.workerWage + selectedRequest?.invoiceDetails?.partsCost)?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">الضريبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.vatValue?.toFixed(2) :selectedRequest?.invoiceDetails?.vatValue?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي ما سيتم دفعه</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.total?.toFixed(2) : selectedRequest?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    {selectedRequest?.status === 'pending-approval' ? <>
                        <div className="pt-[15px] text-end">
                            <div className="inline-block text-white font-bold text-center leading-[40px] rounded-[8px] cursor-pointer select-none bg-success px-[10px] me-[5px]" onClick={()=>handleChangeRequsetStatus('approve',selectedRequest?._id)}>الموافقة علي الطلب</div>
                            <div className="inline-block text-white font-bold text-center leading-[40px] rounded-[8px] cursor-pointer select-none bg-danger px-[10px]" onClick={()=>handleChangeRequsetStatus('reject',selectedRequest?._id)}>رفض الطلب</div>
                        </div>
                    </> : ''}
                </div>
            </div>
            {selectedRequest?.status === 'pending' ? <>
                <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                    <div className="w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={handleClickCancelRequest}>الغاء الطلب</div>
                </div>
            </> : ''}
            {selectedRequest?.status === 'awaiting-price-confirmation' && ((user?._id === selectedRequest?.createdBy) || (user?._id === selectedRequest?.createdBy?._id)) ? <>
                <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                    <div className="w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] me-[16px]" onClick={handleClickCancelRequest}>الغاء الطلب</div>
                    <div className="w-[166px] h-[48px] leading-[48px] bg-darkBlue text-white border-[1px] border-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={handleClickCancelConfirmPriceChange}>التأكيد و الدفع</div>
                </div>
            </> : ''}
             {(selectedRequest?.status === 'pending-approval-exceeded-limit' && ['OWNER','ADMINISTRATOR'].includes(user?.role)) ? <>
                <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                    <div className="w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] me-[16px]" onClick={()=>handleClickChangeRequestStatus('rejected')}>رفض الطلب</div>
                    <div className="w-[166px] h-[48px] leading-[48px] bg-darkBlue text-white border-[1px] border-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={()=>handleClickChangeRequestStatus('pending')}>قبول الطلب و الدفع</div>
                </div>
            </> : ''}
            {['done','reviewed'].includes(selectedRequest?.status) ?
                <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                    <div className="w-[201px] h-[48px] leading-[48px] bg-white text-darkBlue border-[1px] border-dartext-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={handleClickShowHelpModal}>احتاج إلى مساعدة</div>
                </div> : ''
            }
        </RequestModal> }

        {showCancelRequestModal && <ModalContainer maxWidth={'775px'} heading="إلغاء طلب مستفيد" handleCloseModal={handleCloseCancelRequestModal}>
            
            <div className=" border-b-[1px] border-grey-100 leading-[70px]">
                <p className="font-[400] text-[16px] text-grey-600">من فضلك قم باختيار سبب الإلغاء حتى يتم إبلاغ مسؤول الوحدة</p>
            </div>

            <div className="">
                <RadioInput name={'cancellationReasons-'+selectedRequest?._id} options={CancellationReasons} onChange={(value)=>setSelectedCancellationReason(value)} value={selectedCancellationReason} onSelect={setSelectedCancellationOption} selected={selectedCancellationOption} />
            </div>

            <div className="w-full h-[70px] bg-white text-end pt-[20px] border-t-[1px] border-grey-100">
                    <div className={`w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] ${isCancelRequestDisabled ? 'opacity-50 pointer-events-none' : ''}`} onClick={isCancelRequestDisabled ? null : handleClickCancelRequestAction}>الغاء الطلب</div>
                </div>

        </ModalContainer>}

        {showHelpModal && <ModalContainer maxWidth={'775px'} heading="من فضلك قم بتعبئة البيانات التالية لرفع شكوى" handleCloseModal={handleClickCloseHelpModal}>
                    
                    <div className=" border-b-[1px] border-grey-100 leading-[70px]">
                        <p className="font-[400] text-[16px] text-grey-600">سيتم ارسال الشكوي الي الدعم وسيقوم احد عملائنا بالتواصل معك في اقرب وقت ممكن</p>
                    </div>
        
                    <div className="pt-[24px]">
                        <InputField isRequird label={`موضوع الشكوى`} placeholder={'من فضلك اكتب موضوع الشكوي'} value={ticketForm?.complaintSubject} error={errors?.complaintSubject} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setTicketForm({ ...ticketForm, complaintSubject: e.target.value }); hideError('complaintSubject')}} />
                    </div>
        
                    <div className="pb-[14px] pt-[14px]">
                       <TextArea isRequird label={`تفاصيل الشكوى`} placeholder={'اكتب موضوع الشكوي لنتمكن من مساعدتك'} value={ticketForm?.complaintText} error={errors?.complaintText} errorMessage={errors?.complaintText} translateError={true} onChange={(e)=>{ setTicketForm({ ...ticketForm, complaintText: e.target.value }); hideError('complaintText')}} />
                    </div>
        
                    <div className="w-full h-[70px] bg-white text-end pt-[20px] border-t-[1px] border-grey-100">
                        <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleClickCloseHelpModal}>إلغاء</div>
                        <NormalButton isDisabled={isActionButtonDisabled} label={'ارسال الشكوي'} onClick={handleClickSendTicket} />
                    </div>
        
                </ModalContainer>}

        <Toast toast={toast} setToast={setToast} />
        </>
    )
}